import React from 'react'
import { Link } from '@mui/material'
import { useHistory } from 'react-router'

const CellLink = ({ data, value, styles }) => {
    const history = useHistory()
    const style = {
        textAlign: 'left',
        textDecoration: 'none',
        ...styles,
    }
    const {
        location: { pathname },
    } = history

    return (
        <Link
            component="button"
            onClick={() => history.push(`${pathname}/${data.id}`)}
            style={style}
            data-ai-explain={`Open record: ${value}`}
        >
            {value}
        </Link>
    )
}

export default CellLink
